import { Route } from '@angular/router';
import { IEnvironment, PlaningModules, EnvironmentNames } from '../app/shared/services/environment.service';

export const environment: IEnvironment = {
  production: false,
  name: EnvironmentNames.Local,
  module: PlaningModules.SLAdmin,
  routes:  [
    { path: 'platform', loadChildren: () => import('../app/sightlines-admin/sightlines.module').then(m => m.SightlinesModule) },
    { path: '', redirectTo: '/platform/dashboard', pathMatch: 'full' }
  ] as Route[]
};
